import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from './auth.service';

/**
 * Handles the redirect back from the external Authenticator Service. Expects the issued
 * JWT as a "token" query parameter -- the exact redirect contract (query param vs.
 * fragment, parameter name) is an assumption pending confirmation against the real
 * Authenticator Service (see the Sprint 1 deliverables report's Risks & Assumptions).
 * If no token is present, this is treated as "not logged in yet," not an error.
 */
@Component({
  selector: 'app-auth-callback',
  standalone: true,
  template: `
    @if (!hasToken) {
      <p>You are not signed in. Please sign in through your organization's login page.</p>
    } @else {
      <p>Signing you in&hellip;</p>
    }
  `,
})
export class AuthCallbackComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  protected hasToken = false;

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (token) {
      this.hasToken = true;
      this.authService.setToken(token);
      void this.router.navigateByUrl('/');
    }
  }
}
